import { FsForwardCupModeLongFormat } from "db/model/match/Set/CupModeLong/Forward/FsForwardCupModeLongFormat";
import { isPlayCondition } from "model/Match/PlayCondition";
import { ForwardCupModeLongFormat } from "model/Match/Set/CupMode/Format/ForwardCupModeLongFormat";
import { mapSetFormatBase } from "../../FsSetFormat";
import { mapCupModePoints } from "../../CupMode/FsCupModePoints";

export const mapForwardCupModeLongFormat = (
  fsModel: FsForwardCupModeLongFormat
): ForwardCupModeLongFormat | undefined => {
  // We don't currently support the logic for non finalist mode
  if (!fsModel.finalist) {
    return undefined;
  }

  const base = mapSetFormatBase(fsModel);
  if (
    !base ||
    !fsModel.numTracks ||
    !fsModel.pointsLimit ||
    !fsModel.points ||
    !isPlayCondition(fsModel.playCondition)
  ) {
    return undefined;
  }

  const points = mapCupModePoints(fsModel.points);
  if (!points) {
    return undefined;
  }

  return {
    ...base,
    finalist: fsModel.finalist,
    numTracks: fsModel.numTracks,
    playCondition: fsModel.playCondition,
    points,
    pointsLimit: fsModel.pointsLimit,
    requiredTeamWinners: fsModel.requiredTeamWinners,
  };
};
